import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { USE_MOCK_DATA } from './services/api';

// Título dinámico según modo mock
document.title = USE_MOCK_DATA ? 'GeoClientes - Demo' : 'GeoClientes';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
